<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Роли</div>
            <a class="title-block__btn btn-add btn-primary btn" href="/access-add-role">Добавить </a>
        </div>
        <div class="title-block__right d-none d-md-flex">
            <div class="title-block__amount">30 записей</div>
        </div>
    </div>
    <div class="filter-table">
        <div class="filter-table__input-wrap search-control"><input type="text" class="search-control__input form-control"
                placeholder="Поиск">
            <button class="search-control__input-btn reset-btn">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5 8.333a5.834 5.834 0 1011.667 0 5.834 5.834 0 00-11.667 0zM17.5 17.5l-5-5"
                        stroke="currentColor" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>
    </div>
    <div class="user-cards-list">
        <!-- Здесь для примера перечислим несколько ролей -->
        <div class="user-card" v-for="item in roles">
            <a href="/access-edit-role" class="user-card__link" title="Редактировать роль">
                <picture class="user-card__pic">
                    <img src="/images/avatar-lg.png" alt="">
                </picture>
                <div class="user-card__title">
                    <div class="user-card__name">{{ item }}</div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "AccessRoleList",
    data() {
        return {
            roles: [
                'Администратор',
                'Руководитель',
                'Программист',
                'Клиент',
                'Технический писатель',
                'Менеджер по персоналу',
                'Специалист',
                'Менеджер'
            ]
        }
    }
};
</script>
